export class ModuleModel {
  id?: string;
  name: string;
  companyCode: string;
  storeCode: string;
  status: ModuleStatusEnum;
  orderId: string;
  category: ModuleCategoryEnum;
  stationId: string;
  userName: string;
  updatedAt: Date;
  createdAt: Date;

  constructor(data: Partial<ModuleModel | any> = {}) {
    this.id = data.id;
    this.name = data.name;
    this.companyCode = data.companyCode;
    this.storeCode = data.storeCode;
    this.status = data.status;
    this.orderId = data.orderId;
    this.category = data.category;
    this.stationId = data.stationId;
    this.userName = data.userName;
    this.updatedAt = data.updatedAt;
    this.createdAt = data.createdAt;
  }
}

export enum ModuleStatusEnum {
  OPENING = "OPENING",
  CLOSING = "CLOSING",
  WITHDRAW = "WITHDRAW",
}

export enum ModuleCategoryEnum {
  TABLE = "TABLE",
  DELIVERY = "DELIVERY",
}

export const CATEGORY_META: Record<ModuleCategoryEnum, { name: string }> = {
  [ModuleCategoryEnum.TABLE]: { name: "Mesas" },
  [ModuleCategoryEnum.DELIVERY]: { name: "Domicilios" },
};

export const CATEGORIES_LIST = Object.entries(CATEGORY_META).map(
  ([id, meta]) => ({
    id: id as ModuleCategoryEnum,
    name: meta.name,
  })
);

export const STATUS_COLORS: Record<ModuleStatusEnum, string> = {
  [ModuleStatusEnum.OPENING]: "#4caf50",
  [ModuleStatusEnum.CLOSING]: "#ff9800",
  [ModuleStatusEnum.WITHDRAW]: "#f44336",
};

export const STATUS_LABELS: Record<ModuleStatusEnum, string> = {
  OPENING: "Abierto",
  CLOSING: "Cerrado",
  WITHDRAW: "Cobro",
};

export const CATEGORY_COLORS: Record<ModuleCategoryEnum, string> = {
  [ModuleCategoryEnum.TABLE]: "#2196f3",
  [ModuleCategoryEnum.DELIVERY]: "#9c27b0",
};
